enum ExternalCardProvider {
  SHELL = 'Shell',
}

export default ExternalCardProvider
